import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, toHandlers as _toHandlers, mergeProps as _mergeProps, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/right_angle.svg'
import _imports_1 from '@/assets/svg/azi.svg'
import _imports_2 from '@/assets/svg/cube-resize.svg'
import _imports_3 from '@/assets/svg/clip_left.svg'


const _withScopeId = n => (_pushScopeId("data-v-8668f264"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "toolhelper",
  class: "tool-helper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-grip-horizontal" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { style: {"white-space":"nowrap"} }
const _hoisted_8 = { class: "position-menu-item" }
const _hoisted_9 = { class: "position-menu-label" }
const _hoisted_10 = { class: "position-menu-value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-left secondary" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-right secondary" }, null, -1))
const _hoisted_13 = { class: "position-menu-item" }
const _hoisted_14 = { class: "position-menu-label" }
const _hoisted_15 = { class: "position-menu-value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-left secondary" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-right secondary" }, null, -1))
const _hoisted_18 = { class: "position-menu-item" }
const _hoisted_19 = { class: "position-menu-label" }
const _hoisted_20 = { class: "position-menu-value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-left secondary" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-right secondary" }, null, -1))
const _hoisted_23 = { class: "position-menu-item" }
const _hoisted_24 = { class: "position-menu-label" }
const _hoisted_25 = { class: "position-menu-value" }
const _hoisted_26 = { style: {"white-space":"nowrap"} }
const _hoisted_27 = { class: "position-menu-item" }
const _hoisted_28 = { class: "position-menu-label" }
const _hoisted_29 = { class: "position-menu-value" }
const _hoisted_30 = { class: "position-menu-item" }
const _hoisted_31 = { class: "position-menu-label" }
const _hoisted_32 = { class: "position-menu-value" }
const _hoisted_33 = { class: "position-menu-item" }
const _hoisted_34 = { class: "position-menu-label" }
const _hoisted_35 = { class: "position-menu-value" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sync secondary" }, null, -1))
const _hoisted_37 = { class: "position-menu-item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-menu-label" }, "X", -1))
const _hoisted_39 = { class: "position-menu-value" }
const _hoisted_40 = { class: "position-menu-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-menu-label" }, "Y", -1))
const _hoisted_42 = { class: "position-menu-value" }
const _hoisted_43 = { class: "position-menu-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-menu-label" }, "Z", -1))
const _hoisted_45 = { class: "position-menu-value" }
const _hoisted_46 = { style: {"white-space":"nowrap"} }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sync" }, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-object-ungroup" }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1))
const _hoisted_57 = [
  _hoisted_56
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dragStart && _ctx.dragStart(...args))),
      class: "tool-helper-btn grip"
    }, _hoisted_3, 32),
    _createElementVNode("div", {
      class: _normalizeClass(["tool-helper-input", { disabled: _ctx.clipType == 'Box' }])
    }, [
      _hoisted_4,
      _createVNode(_component_imdex_text_field, {
        value: _ctx.dip,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dip) = $event)),
        type: "number",
        style: {"max-width":"60px"},
        small: ""
      }, null, 8, ["value"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["tool-helper-input", { disabled: _ctx.clipType == 'Box' }])
    }, [
      _hoisted_5,
      _createVNode(_component_imdex_text_field, {
        value: _ctx.azimuth,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.azimuth) = $event)),
        type: "number",
        style: {"max-width":"60px"},
        small: ""
      }, null, 8, ["value"])
    ], 2),
    _createVNode(_component_imdex_tooltip, {
      nudgeY: -10,
      top: ""
    }, {
      activator: _withCtx((on) => [
        _withDirectives(_createElementVNode("div", _mergeProps(_toHandlers(on), { class: "tool-helper-btn" }), [
          _createElementVNode("i", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetOrigin && _ctx.resetOrigin(...args))),
            class: "fa fa-location secondary"
          })
        ], 16), [
          [_vShow, _ctx.clipType == 'Box']
        ])
      ]),
      tooltip: _withCtx(() => [
        _createElementVNode("span", {
          style: {"white-space":"nowrap","display":"block"},
          innerHTML: _ctx.$t(`ssa.visualizer.toolHelper.resetBoxOrigin`)
        }, null, 8, _hoisted_6)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", {
      onClick: _cache[18] || (_cache[18] = ($event: any) => ((_ctx.positionMenu = !_ctx.positionMenu), (_ctx.scaleMenu = false), (_ctx.rotationMenu = false))),
      class: "tool-helper-btn"
    }, [
      _createVNode(_component_imdex_tooltip, {
        nudgeY: -10,
        top: ""
      }, {
        activator: _withCtx((on) => [
          _createElementVNode("img", _mergeProps(_toHandlers(on), {
            src: _imports_2,
            alt: ""
          }), null, 16)
        ]),
        tooltip: _withCtx(() => [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.boxPosition`)), 1)
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        "enter-active-class": "fadeInUp",
        "leave-active-class": "fadeOutDown"
      }, {
        default: _withCtx(() => [
          (_ctx.positionMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"])),
                class: "position-menu animated-fast"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.easting`)), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_imdex_btn, {
                      icon: "",
                      text: "",
                      mini: "",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.incrementDown('positionX'))),
                      depressed: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_imdex_text_field, {
                      small: "",
                      type: "number",
                      onChange: _cache[5] || (_cache[5] = ($event) => (_ctx.tempPositionX = $event)),
                      onKeypress: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.positionX = _ctx.tempPositionX), ["enter"])),
                      value: Math.round(_ctx.positionX * 100) / 100
                    }, null, 8, ["value"]),
                    _createVNode(_component_imdex_btn, {
                      icon: "",
                      text: "",
                      mini: "",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.incrementUp('positionX'))),
                      depressed: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.northing`)), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_imdex_btn, {
                      icon: "",
                      text: "",
                      mini: "",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.incrementDown('positionY'))),
                      depressed: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_imdex_text_field, {
                      small: "",
                      type: "number",
                      onChange: _cache[9] || (_cache[9] = ($event) => (_ctx.tempPositionY = $event)),
                      onKeypress: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.positionY = _ctx.tempPositionY), ["enter"])),
                      value: Math.round(_ctx.positionY * 100) / 100
                    }, null, 8, ["value"]),
                    _createVNode(_component_imdex_btn, {
                      icon: "",
                      text: "",
                      mini: "",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.incrementUp('positionY'))),
                      depressed: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.elevation`)), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_imdex_btn, {
                      icon: "",
                      text: "",
                      mini: "",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.incrementDown('positionZ'))),
                      depressed: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_imdex_text_field, {
                      small: "",
                      type: "number",
                      onChange: _cache[13] || (_cache[13] = ($event) => (_ctx.tempPositionZ = $event)),
                      onKeypress: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.positionZ = _ctx.tempPositionZ), ["enter"])),
                      value: Math.round(_ctx.positionZ * 100) / 100
                    }, null, 8, ["value"]),
                    _createVNode(_component_imdex_btn, {
                      icon: "",
                      text: "",
                      mini: "",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.incrementUp('positionZ'))),
                      depressed: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.increment`)), 1),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_imdex_text_field, {
                      small: "",
                      type: "number",
                      value: _ctx.increment,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.increment) = $event))
                    }, null, 8, ["value"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.clipType == 'Box']
    ]),
    (_ctx.clipType == 'Box')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[28] || (_cache[28] = ($event: any) => ((_ctx.scaleMenu = !_ctx.scaleMenu), (_ctx.positionMenu = false), (_ctx.rotationMenu = false))),
          class: "tool-helper-btn"
        }, [
          _createVNode(_component_imdex_tooltip, {
            nudgeY: -10,
            top: ""
          }, {
            activator: _withCtx((on) => [
              _createElementVNode("i", _mergeProps(_toHandlers(on), { class: "fa fa-expand-arrows-alt secondary" }), null, 16)
            ]),
            tooltip: _withCtx(() => [
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.boxSize`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "enter-active-class": "fadeInUp",
            "leave-active-class": "fadeOutDown"
          }, {
            default: _withCtx(() => [
              (_ctx.scaleMenu)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onMouseover: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"])),
                    onMouseenter: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"])),
                    onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"])),
                    class: "position-menu animated-fast"
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.easting`)), 1),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_imdex_text_field, {
                          small: "",
                          type: "number",
                          onChange: _cache[19] || (_cache[19] = ($event) => (_ctx.tempScaleX = $event)),
                          onKeypress: _cache[20] || (_cache[20] = _withKeys(($event: any) => (
									_ctx.scaleX =
										typeof _ctx.tempScaleX == 'number'
											? _ctx.tempScaleX > 0
												? _ctx.tempScaleX
												: 1
											: _ctx.tempScaleX.target.value > 0
											? _ctx.tempScaleX.target.value
											: 1
								), ["enter"])),
                          value: Math.round(_ctx.scaleX)
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.northing`)), 1),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_imdex_text_field, {
                          small: "",
                          type: "number",
                          onChange: _cache[21] || (_cache[21] = ($event) => (_ctx.tempScaleY = $event)),
                          onKeypress: _cache[22] || (_cache[22] = _withKeys(($event: any) => (
									_ctx.scaleY =
										typeof _ctx.tempScaleY == 'number'
											? _ctx.tempScaleY > 0
												? _ctx.tempScaleY
												: 1
											: _ctx.tempScaleY.target.value > 0
											? _ctx.tempScaleY.target.value
											: 1
								), ["enter"])),
                          value: Math.round(_ctx.scaleY)
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.elevation`)), 1),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_imdex_text_field, {
                          small: "",
                          type: "number",
                          onChange: _cache[23] || (_cache[23] = ($event) => (_ctx.tempScaleZ = $event)),
                          onKeypress: _cache[24] || (_cache[24] = _withKeys(($event: any) => (
									_ctx.scaleZ =
										typeof _ctx.tempScaleZ == 'number'
											? _ctx.tempScaleZ > 0
												? _ctx.tempScaleZ
												: 1
											: _ctx.tempScaleZ.target.value > 0
											? _ctx.tempScaleZ.target.value
											: 1
								), ["enter"])),
                          value: Math.round(_ctx.scaleZ)
                        }, null, 8, ["value"])
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_imdex_tooltip, null, {
      activator: _withCtx((on) => [
        false
          ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, _toHandlers(on), {
              onClick: _cache[36] || (_cache[36] = ($event: any) => (
						(_ctx.rotationMenu = !_ctx.rotationMenu), (_ctx.positionMenu = false), (_ctx.scaleMenu = false)
					)),
              class: "tool-helper-btn"
            }), [
              _hoisted_36,
              _createVNode(_Transition, {
                "enter-active-class": "fadeInUp",
                "leave-active-class": "fadeOutDown"
              }, {
                default: _withCtx(() => [
                  (_ctx.rotationMenu)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[35] || (_cache[35] = _withModifiers(() => {}, ["stop"])),
                        class: "position-menu animated-fast"
                      }, [
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_imdex_text_field, {
                              small: "",
                              type: "number",
                              onChange: _cache[29] || (_cache[29] = ($event) => (_ctx.tempRotationX = $event)),
                              onKeypress: _cache[30] || (_cache[30] = _withKeys(($event: any) => (_ctx.rotationX = _ctx.tempRotationX), ["enter"])),
                              value: Math.round(_ctx.rotationX)
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_imdex_text_field, {
                              small: "",
                              type: "number",
                              onChange: _cache[31] || (_cache[31] = ($event) => (_ctx.tempRotationY = $event)),
                              onKeypress: _cache[32] || (_cache[32] = _withKeys(($event: any) => (_ctx.rotationY = _ctx.tempRotationY), ["enter"])),
                              value: Math.round(_ctx.rotationY)
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_imdex_text_field, {
                              small: "",
                              type: "number",
                              onChange: _cache[33] || (_cache[33] = ($event) => (_ctx.tempRotationZ = $event)),
                              onKeypress: _cache[34] || (_cache[34] = _withKeys(($event: any) => (_ctx.rotationZ = _ctx.tempRotationZ), ["enter"])),
                              value: Math.round(_ctx.rotationZ)
                            }, null, 8, ["value"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 16))
          : _createCommentVNode("", true)
      ]),
      tooltip: _withCtx(() => [
        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.depth`)), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_imdex_tooltip, {
      nudgeY: -10,
      top: ""
    }, {
      activator: _withCtx((on) => [
        _createElementVNode("div", _mergeProps(_toHandlers(on), {
          onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.invertClip && _ctx.invertClip(...args))),
          class: ["tool-helper-btn", { disabled: _ctx.clipType == 'Box' }]
        }), _hoisted_48, 16)
      ]),
      tooltip: _withCtx(() => [
        _createElementVNode("span", {
          style: {"white-space":"nowrap","display":"block"},
          innerHTML: _ctx.$t(`ssa.visualizer.toolHelper.invertClip`)
        }, null, 8, _hoisted_49)
      ]),
      _: 1
    }),
    _createVNode(_component_imdex_tooltip, {
      nudgeY: -10,
      top: ""
    }, {
      activator: _withCtx((on) => [
        _createElementVNode("div", _mergeProps(_toHandlers(on), {
          onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
          class: "tool-helper-btn"
        }), _hoisted_51, 16)
      ]),
      tooltip: _withCtx(() => [
        _createElementVNode("span", {
          style: {"white-space":"nowrap","display":"block"},
          innerHTML: _ctx.$t(`ssa.visualizer.toolHelper.resetClip`)
        }, null, 8, _hoisted_52)
      ]),
      _: 1
    }),
    _createVNode(_component_imdex_tooltip, {
      nudgeY: -10,
      top: ""
    }, {
      activator: _withCtx((on) => [
        _createElementVNode("div", _mergeProps(_toHandlers(on), {
          onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.applyToAll && _ctx.applyToAll(...args))),
          class: ["tool-helper-btn", { 'active-toggle': _ctx.applyToAllEnabled }]
        }), _hoisted_54, 16)
      ]),
      tooltip: _withCtx(() => [
        _createElementVNode("span", {
          style: {"white-space":"nowrap","display":"block"},
          innerHTML: 
						_ctx.$t(`ssa.visualizer.toolHelper.applyToAll`) +
						' - ' +
						(_ctx.applyToAllEnabled ? 'On' : 'Off')
					
        }, null, 8, _hoisted_55)
      ]),
      _: 1
    }),
    _createVNode(_component_imdex_btn, {
      compact: "",
      small: "",
      secondary: "",
      text: "",
      onClick: _ctx.toggleClipType
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.${_ctx.clipType}`)), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_imdex_btn, {
      compact: "",
      small: "",
      secondary: "",
      text: "",
      onClick: _ctx.clear
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(`ssa.visualizer.toolHelper.clearClip`)), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("div", {
      onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
      class: "tool-helper-btn"
    }, _hoisted_57)
  ], 512))
}